module.exports = __webpack_public_path__ + "img/bar_02.d6abb52f.jpg";